import moment from 'moment';
import 'moment/locale/ja';
import { useEffect, useRef, useState,useLayoutEffect } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router";
import useMedia from "use-media";
import { cancelReserve } from '../../const';
import common from '../../resources/js/common/common';
import { Button } from "../atoms/button";
import { ModalClose } from "../atoms/modalClose";
import './../../resources/css/popup/golf_cancel_popup.css';

const GolfCancelPopup = (props) => {
    const {
        state,
        reserveCheckInfo,
        onClickCloseCancelPopupWindow,
    } = props;

    const store = useStore();
    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const popupRef = useRef(null);
    const [errorFlg, setErrorFlg] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useLayoutEffect(() => {
        popupRef.current.scrollTop = 0;
    },[]);

    const onClose = () => {
        onClickCloseCancelPopupWindow();
        setErrorFlg(false);
    }

    // 予約キャンセル後処理
    const afterCancelReservation = (res) => {
        // キャンセル後のリスト更新等必要な処理を実施する。
        console.log("キャンセル処理");
        if (res.data.resultCode === 0) {
            //キャンセル成功画面へ遷移
            onClickCloseCancelPopupWindow();
            history.push("/reserve/golf/cancel");
        } else {
            setErrorFlg(true);
        }
    }

    // 予約キャンセル
    const onClickCancel = () => {
        //キャンセルAPI利用
        let flg = "0";
        if(reserveCheckInfo.planName === "１人予約" ||  reserveCheckInfo.planName === "キャンセル待ち予約"){
            flg = "1"
        }
        common.doPost("/reserve/api/golf/requestGolfCancel", { reservationNo: reserveCheckInfo.reservationNo,requestFlg:flg}, afterCancelReservation);
    }

    return (
        <div ref={popupRef} className={state.golfReservationCancelPopup ? "golfCancelPopupShow" : "golfPopupNone"} id="js-popup">
            <div className={isMobilePhone ? "golfCancelPopupContentSp" : "golfCancelPopupContent"}>
                <div className={isMobilePhone ? "golfCancelPopupSpHead" : "golfCancelPopupPcHead"}>
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClose()} />
                    <h4 className="golfCancelPopupHeadTitle" >予約キャンセル</h4>
                </div>
                <div style={{height:"67px"}}/>
                {errorFlg ?
                    <div className='golfCancelPopupBodyArea'>
                        予約のキャンセルに失敗しました。
                    </div>
                    :
                    <div className='golfCancelPopupBodyArea'>
                        予約のキャンセルを行いますか？
                    </div>
                }
                {errorFlg ?
                    <div className={isMobilePhone ? 'golfCancelPopupBtnAreaSp' : 'golfCancelPopupBtnArea'}>
                        <Button buttonText="OK" className={"golfCancelYesBtn"} onClick={onClose} />
                    </div>
                    :
                    <div className={isMobilePhone ? 'golfCancelPopupBtnAreaSp' : 'golfCancelPopupBtnArea'}>
                        <Button buttonText="はい" className={"golfCancelYesBtn"} onClick={onClickCancel} />
                        <Button buttonText="いいえ" className={"golfCancelNoBtn"} onClick={onClose} />
                    </div>
                }
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};


const mapStateToProps = (state) => {
    return {
        reserveCheckInfo: state.reserveCheckInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setReserveCheckInfo: (item) => {
            dispatch({ type: "RESERVE_CHECK_INFO", payload: { reserveCheckInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(GolfCancelPopup);
